import React, { Component } from 'react';
import BodyClassName from 'react-body-classname';
import classnames from 'classnames';
import { Form } from 'react-redux-form';
import Filters from '../filters';
import Textfield from '../ui/text-field';

import SearchResults from './search-results';

class Search extends Component {
    handleSubmit = e => {
        this.props.fetchSearchResultsThunk(e.name);
    };

    handleChange = e => {
        if (e.target.value.length >= 4) {
            this.props.fetchSearchResultsThunk(e.target.value);
        } else if (e.target.value.length === 0) {
            this.props.resetSearchResults();
        }
    };

    render() {
        let bodyClass = classnames(
                { 'disable-scrolling': this.props.searchActive },
                { 'search--open': this.props.searchActive },
                { 'filter--open': this.props.isSearchFilterOpen }
            ),
            overlayClass = classnames({ 'is-active': this.props.searchActive }),
            searchClass = classnames('search', {
                'is-active': this.props.searchActive
            });

        return (
            <BodyClassName className={bodyClass}>
                <Form
                    className="search-filter"
                    model="search"
                    onSubmit={this.handleSubmit}
                >
                    <div
                        id="overlay-bg"
                        onClick={this.props.closeSearch}
                        className={overlayClass}
                    />
                    <section className={searchClass}>
                        <div className="form form--search">
                            <button
                                onClick={this.props.closeSearch}
                                className="panel__close-btn"
                            >
                                <svg className="icon icon-close">
                                    <use xlinkHref="#icon-close" />
                                </svg>
                            </button>

                            <Textfield
                                model="search.name"
                                title="Search"
                                placeholder="Start Typing"
                                onChange={this.handleChange}
                            />
                            <span className="form__result-info">
                                {this.props.searchResultsNumber} results found
                            </span>
                        </div>

                        <div className="search__list">
                            {this.props.searchLoading ? (
                                <div className="search__loading">
                                    Loading...
                                </div>
                            ) : (
                                this.props.searchResults.map(item => {
                                    return (
                                        <SearchResults
                                            key={item.id}
                                            {...item}
                                        />
                                    );
                                })
                            )}
                        </div>
                    </section>

                    <Filters
                        showClose={false}
                        includeDates
                        model="search"
                        isActive={this.props.isSearchFilterOpen}
                        fromDate={this.props.fromDate}
                    />
                </Form>
            </BodyClassName>
        );
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/search/index.js